import { gql } from '@apollo/client';

import { threadFragment } from '../fragments';

export default gql`
  query GetThread($courseId: String, $threadId: String!) {
    thread(courseId: $courseId, threadId: $threadId)
      @rest(
        type: "Thread"
        path: "/courses/{args.courseId}/threads/{args.threadId}"
      ) {
      ...Thread
    }
  }
  ${threadFragment}
`;
